module.exports = __webpack_public_path__ + "static/media/ISSA_CFT21.c9c462c2.jpg";